"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GATEWAY_METHODS = exports.LOG_STREAM_MAX_BACKLOG_LINES = exports.LOG_STREAM_DEFAULT_UNIT = exports.LOG_STREAM_MAX_MS = exports.SSH_TUNNEL_TIMEOUT_MS = exports.LOG_UPLOAD_TIMEOUT_MS = void 0;
// gateway.* method definitions: one line per method, naming its shapes (gateway.types.ts), who may call it, and its limits.
const define_js_1 = require("./define.js");
// A journal read plus an S3 PUT over a mobile link.
exports.LOG_UPLOAD_TIMEOUT_MS = 120000;
// The tunnel's port poll alone runs for 150s.
exports.SSH_TUNNEL_TIMEOUT_MS = 180000;
// Hard ceiling on a log tail; it otherwise runs until the viewer stops it.
exports.LOG_STREAM_MAX_MS = 15 * 60 * 1000;
// Unit a log tail follows when none is named.
exports.LOG_STREAM_DEFAULT_UNIT = 'myapp.service';
// Most backlog lines a log tail may replay before it starts following.
exports.LOG_STREAM_MAX_BACKLOG_LINES = 500;
exports.GATEWAY_METHODS = {
    'gateway.info': (0, define_js_1.defineMethod)({ access: { level: 'admin' } }),
    'gateway.setDebug': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true } }),
    // One upload at a time: two would only compete for the same mobile uplink; the browser sends no key, the cloud mints it.
    'gateway.uploadLogs': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true }, maxConcurrent: 1, budgetMs: exports.LOG_UPLOAD_TIMEOUT_MS }),
    'gateway.sshTunnel': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true }, maxConcurrent: 1, budgetMs: exports.SSH_TUNNEL_TIMEOUT_MS }),
    // One tail at a time, with a hard ceiling so a dropped socket cannot leave one running forever.
    'gateway.logStream': (0, define_js_1.defineStream)({ access: { level: 'admin' }, maxConcurrent: 1, budgetMs: exports.LOG_STREAM_MAX_MS }),
    // Also written to the device log, so the journal has the figures the caller saw.
    'gateway.stats': (0, define_js_1.defineMethod)({ access: { level: 'admin' } }),
    // Clears what stops the device retrying an update, then retries the release the cloud asks for: a download and a reboot, hence god-only.
    'gateway.retryUpdate': (0, define_js_1.defineMethod)({ access: { level: 'admin', god: true }, maxConcurrent: 1 }),
};
